import { render, staticRenderFns } from "./dashboard-sanea.vue?vue&type=template&id=68430c2d&scoped=true"
import script from "./dashboard-sanea.vue?vue&type=script&lang=js"
export * from "./dashboard-sanea.vue?vue&type=script&lang=js"
import style0 from "./dashboard-sanea.vue?vue&type=style&index=0&id=68430c2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68430c2d",
  null
  
)

export default component.exports